import React, {useEffect} from 'react';
import {CommonLoaderDialog} from '~/entities/dialogs';
import {RsnDialog, useBoolean} from '~/library/ui-kit';
import {useCaptchaState} from '../api/useCaptcha';

/**
 * What time should be considered as long time to wait for execution to complete
 */
const LONG_EXECUTION_MS = 1000;

export function CaptchaUsageMention() {
    const {executeInitAt, executeDoneAt} = useCaptchaState();
    const [isLong, setIsLong] = useBoolean();
    const isPending = executeInitAt > executeDoneAt;
    useEffect(() => {
        if (!isPending) {
            return;
        }
        const timeoutId = setTimeout(setIsLong.on, LONG_EXECUTION_MS);
        return () => {
            clearTimeout(timeoutId);
            setIsLong.off();
        };
    }, [isPending]);
    return (
        <RsnDialog.Controller>
            {isPending && isLong && <CommonLoaderDialog reason={"Checking if you're a human"} />}
        </RsnDialog.Controller>
    );
}
